export interface Modal {
    isOpen: boolean;
    width?: number;
    height?: number;
    maxHeight?: string | number;
    maxWidth?: string | number;
    minHeight?: string | number;
    minWidth?: string | number;
    overflow?: string;
    zIndex?: number;
    header?: {
        textKey?: string;
        secondLineTextKey?: string;
        textAlignment?: 'left' | 'center' | 'right';
        showSeparator?: boolean;
        textSize?: number;
        icon?: string;
    };
    textAlignment?: 'left' | 'center' | 'right';
    textKey?: string;
    textStyle?: { [key: string]: string | number };
    actions?: ModalActions;
    actionsAlignment?: 'left' | 'center' | 'right' | 'stretch' | 'between' | 'spaced';
    fullScreen?: boolean;
    fitContent?: boolean;
    preview?: boolean;
    content?: boolean;
    params?: any;
    backgroundColor?: string;
    fontColor?: string;
    padding?: number;
    doNotAutoFocus?: boolean;
}

export enum ModalActionType {
    cancel = 'cancel',
    delete = 'delete',
    submit = 'submit',
    ok = 'OK',
}

export interface ModalActions {
    [ModalActionType.submit]?: ModalAction;
    [ModalActionType.cancel]?: ModalAction;
    [ModalActionType.delete]?: ModalAction;
}

interface ModalAction {
    show?: boolean;
    textKey?: string;
    buttonClass?: string;
    width?: number;
    disabled?: () => boolean;
    hidden?: () => boolean;
}

export enum ModalType {
    form = 'form',
    geoFenceForm = 'geoFenceForm',
    badgeForm = 'badgeForm',
    badgeImport = 'badgeImport',
    keySecret = 'keySecret',
    folder = 'folder',
    parent = 'parent',
    dashboard = 'dashboard',
    group = 'group',
}

export const defaultModal: Modal = {
    isOpen: false,
    width: 400,
    overflow: 'visible',
    actions: {
        [ModalActionType.submit]: {
            show: false,
            textKey: 'shared.generics.confirm',
            buttonClass: 'primary',
        },
        [ModalActionType.cancel]: {
            show: false,
            textKey: 'shared.generics.cancel',
            buttonClass: 'cancel',
        },
        [ModalActionType.delete]: {
            show: false,
            textKey: 'shared.generics.delete',
            buttonClass: 'alert',
        },
    },
};

export const defaultItemExistsModal: Modal = {
    isOpen: true,
    overflow: 'visible',
    header: {
        textAlignment: 'left',
        showSeparator: true,
    },
    actionsAlignment: 'right',
    width: 575,
    content: true,
    actions: {
        'submit': {
            show: true,
            textKey: 'generics.okay',
            buttonClass: 'blue-lt',
            width: 150,
        },
        'cancel': {
            show: true,
            textKey: 'generics.cancel',
            buttonClass: 'cancel',
            width: 150,
        },
    },
};